
import * as types from 'actions/action-types';

var initialState = {
    asset: null,
    asset_pending: false,
    asset_save_pending: false,
    asset_fulfilled: false,
    asset_unsubscribe: false,

    asset_attachments: [],
    asset_attachments_pending: false,
    asset_attachments_fulfilled: false,
    asset_attachments_unsubscribe: false,

    asset_expiring_docs: [],
    asset_expiring_docs_pending: false,
    asset_expiring_docs_fulfilled: false,
    asset_expiring_docs_unsubscribe: false,

    asset_activity_log: [],
    asset_activity_log_pending: false,
    asset_activity_log_fulfilled: false,
    asset_activity_log_unsubscribe: false,

    asset_invoices: [],
    asset_invoices_pending: false,
    asset_invoices_fulfilled: false,
    asset_invoices_unsubscribe: false,
    
    assets: [],
    assets_pending: false,
    assets_fulfilled: false,
    assets_unsubscribe: false,
    
    selected_asset_type_id: 0,
    selected_customer_id: '0',
    show_customer_assets: true,
};

const AssetReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.ASSET + '_PENDING': pending('asset'); break;
        case types.ASSET + '_SAVE_PENDING': save_pending('asset'); break;
        case types.ASSET + '_FULFILLED': fulfilled('asset'); break;
        case types.ASSET + '_SAVE_FULFILLED': save_fulfilled('asset'); break;

        case types.ASSET + '_' + types.ATTACHMENTS + '_PENDING': pending('asset_attachments'); break;
        case types.ASSET + '_' + types.ATTACHMENTS + '_FULFILLED': fulfilled('asset_attachments'); break;
        case types.ASSET + '_' + types.ATTACHMENTS + '_CLEAR': clear('asset_attachments', []); break;

        case types.ASSET + '_' + types.EXPIRING_DOCS + '_PENDING': pending('asset_expiring_docs'); break;
        case types.ASSET + '_' + types.EXPIRING_DOCS + '_FULFILLED': fulfilled('asset_expiring_docs'); break;
        case types.ASSET + '_' + types.EXPIRING_DOCS + '_CLEAR': clear('asset_expiring_docs', []); break;

        case types.ASSET + '_' + types.INVOICES + '_PENDING': pending('asset_invoices'); break;
        case types.ASSET + '_' + types.INVOICES + '_FULFILLED': fulfilled('asset_invoices'); break;
        case types.ASSET + '_' + types.INVOICES + '_CLEAR': clear('asset_invoices', []); break;

        case types.ASSET + '_' + types.ACTIVITY_LOG + '_PENDING': pending('asset_activity_log'); break;
        case types.ASSET + '_' + types.ACTIVITY_LOG + '_FULFILLED': fulfilled('asset_activity_log'); break;
        case types.ASSET + '_' + types.ACTIVITY_LOG + '_CLEAR': clear('asset_activity_log', []); break;

        case types.ASSETS + '_PENDING': pending('assets'); break;
        case types.ASSETS + '_FULFILLED': fulfilled('assets'); break;
        case types.ASSETS + '_CLEAR': clear('assets', {}); break;

        case types.ASSET_TYPE + '_SELECTED': set('selected_asset_type_id'); break;
        case types.CUSTOMER + '_SELECTED': set('selected_customer_id'); break;
        case types.CUSTOMER + '_ASSETS_SELECTED': set('show_customer_assets'); break;

        default: break;
    }

    return state;

    function pending(table) {
        state = {
            ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = {
            ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = {
            ...state,
            [table + '_saved']: action.data,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = {
            ...state,
            [table]: action.data,
            [table + '_pending']: false,
            ...(action.unsubscribe) ? { [table + '_unsubscribe']: (action.unsubscribe) } : {},
        };
    }
    function set(table) {
        state = {
            ...state,
            [table]: action.data,
        };
    }
    function clear(table, value) {
        state = {
            ...state,
            [table]: value,
        };
    }
};
export default AssetReducer;


